import { TasksLinksType } from "@/v2/utils/constants";

export function downloadData(data: string, filename: string) {
  const link = document.createElement("a");
  if (TasksLinksType.includes(filename)) {
    link.target = "_blank";
  } else {
    link.download = filename;
  }
  link.href = data;
  link.style.display = "none";
  document.body.appendChild(link);
  if (link) {
    link.click?.();
  }
  link.remove();
}
